<template>
  <div>
    <div style="display:flex;justify-content:center;align-items:center;font-size: 1.1rem;">
      <div style="margin-top: 15px;margin-bottom: 97px">
        <p style="font-size: 2rem;margin-bottom: 24px;margin-left: 0px;margin-top: 50px">Please Contact Us</p>
        <p style="margin-bottom: 30px;font-size: 1.3rem">For any question or suggestion, please contact:</p>

        <p style="color: #13305D;font-weight: bold;font-size: 1.3rem;margin-bottom: 10px">Xiaopei Shen, Ph.D, Professor</p>
        <p style="font-weight: bold">Email: </p>
        <p><a style="color: #409EFF" href="mailto: xshen@fjmu.edu.cn">xshen@fjmu.edu.cn</a></p>
        <p style="margin-top: 0px;font-weight: bold">Department & Institution:</p>
        <p>Department of Bioinformatics, Fujian Medical University</p>

        <br>
        <br>
        <p style="color: #13305D;font-weight: bold;font-size: 1.3rem;margin-bottom: 10px">Wang Dong, Ph.D, Professor</p>
        <p style="font-weight: bold">Email: </p>
        <p><a style="color:#409EFF;" href="mailto: wangdong79@smu.edu.cn">wangdong79@smu.edu.cn</a> or <a  style="color:#409EFF;" href="mailto: wangdong@ems.hrbmu.edu.cn">wangdong@ems.hrbmu.edu.cn</a></p>
        <p style="margin-top: 0px;font-weight: bold">Department & Institution:</p>
        <p>Department of Bioinformatics, Southern Medical University</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact"
}
</script>

<style scoped>
p{
  margin-top: 0px;
  margin-bottom:  5px;
  margin-left: 40px;
}
a{
  text-decoration: none;
}
</style>